import { apiGet, apiPut } from './apiClient';

export const loginSettingsService = {
  getSettings: async () => apiGet('login-settings'),
  updateSettings: async (data) => apiPut('login-settings', data),
};

export default loginSettingsService;
